/* ── Shared Step Definitions ─────────────────────────────────────────── */

const CUSTOMIZE_PLAN_GROUP = {
  id: 'customizePlan',
  label: 'Customize your plan',
  mobileLabel: 'Customize plan',
  steps: [
    { id: 'plans', pages: ['progressiveplan'] },
    { id: 'addons', pages: ['addons'] },
  ],
};

const YOUR_INFO_GROUP = {
  id: 'yourInfo',
  label: 'Your information',
  steps: [
    { id: 'info', pages: ['contactinfo', 'createprofile', 'creditcheck'] },
  ],
};

const NSE_CHECKOUT_STEPS_DUE_TODAY = [
  { id: 'review', pages: ['expresscheckout', 'shipping'] },
  { id: 'payment', pages: ['payment', 'appointment'] },
  { id: 'terms', pages: ['expresstos'] },
];


const NSE_CHECKOUT_STEPS_NO_DUE_TODAY = [
  { id: 'review', pages: ['expresscheckout', 'shipping', 'appointment'] },
  { id: 'terms', pages: ['expresstos'] },
];

const AAL_CHECKOUT_STEPS_DUE_TODAY = [
  { id: 'review', pages: ['expresscheckout', 'shipping'] },
  { id: 'payment', pages: ['payment', 'appointment'] },
  { id: 'terms', pages: ['expresstos'] },
];

const AAL_CHECKOUT_STEPS_NO_DUE_TODAY = [
  { id: 'review', pages: ['expresscheckout', 'shipping', 'appointment'] },
  { id: 'terms', pages: ['expresstos'] },
];

const buildGroups = (includeInfo, checkoutSteps) => [
  CUSTOMIZE_PLAN_GROUP,
  ...(includeInfo ? [YOUR_INFO_GROUP] : []),
  { id: 'reviewCheckout', label: 'Review & checkout', steps: checkoutSteps },
];

/* ── NSE Step Groups ─────────────────────────────────────────────────── */

export const NSE_GROUPS_WITH_DUE_TODAY = buildGroups(true, NSE_CHECKOUT_STEPS_DUE_TODAY);

export const NSE_GROUPS_WITHOUT_DUE_TODAY = buildGroups(true, NSE_CHECKOUT_STEPS_NO_DUE_TODAY);

/* ── AAL Step Groups ─────────────────────────────────────────────────── */

export const AAL_GROUPS_WITH_DUE_TODAY = buildGroups(false, AAL_CHECKOUT_STEPS_DUE_TODAY);

export const AAL_GROUPS_WITHOUT_DUE_TODAY = buildGroups(false, AAL_CHECKOUT_STEPS_NO_DUE_TODAY);

/* ── Step-to-Page Map ────────────────────────────────────────────────── */

export const STEP_PAGE_MAP = {
  plans: 'progressiveplan.html',
  addons: 'addons.html',
  info: 'contactinfo.html',
  review: 'expresscheckout.html',
  payment: 'payment.html',
  terms: 'expresstos.html',
};

export const GROUP_PAGE_MAP = {
  customizePlan: 'progressiveplan.html',
  yourInfo: 'contactinfo.html',
  reviewCheckout: 'expresscheckout.html',
};

export const resolveInfoRedirectPage = (cdlThrottleList) => (cdlThrottleList.includes('cp_t') ? 'createprofile.html' : 'contactinfo.html');

export const getStepRedirectPage = (stepId, cdlThrottleList) => {
  if (stepId === 'info') return resolveInfoRedirectPage(cdlThrottleList);
  return STEP_PAGE_MAP[stepId];
};

export const getGroupRedirectPage = (groupId, cdlThrottleList) => {
  if (groupId === 'yourInfo') return resolveInfoRedirectPage(cdlThrottleList);
  return GROUP_PAGE_MAP[groupId];
};

/* ── Tagging (data-track) ────────────────────────────────────────────── */

const sameTrackName = (name) => ({ desktop: name, mobile: name });

const CUSTOMIZE_PLAN_TRACK = {
  desktop: CUSTOMIZE_PLAN_GROUP.label,
  mobile: CUSTOMIZE_PLAN_GROUP.mobileLabel,
};

const DATA_TRACK_NAMES = {
  plans: CUSTOMIZE_PLAN_TRACK,
  customizePlan: CUSTOMIZE_PLAN_TRACK,
  addons: sameTrackName('addons'),
  info: sameTrackName(YOUR_INFO_GROUP.label),
  yourInfo: sameTrackName(YOUR_INFO_GROUP.label),
  review: sameTrackName('Review & checkout'),
  reviewCheckout: sameTrackName('Review & checkout'),
  payment: sameTrackName('payment'),
  terms: sameTrackName('expresstos'),
};

export const getProgressBarDataTrack = (name) => JSON.stringify({ type: 'link', name: `${name} - nav` });

const getDataTrack = (id, isMobile = false) => {
  const entry = DATA_TRACK_NAMES[id];
  if (!entry) return undefined;
  const name = isMobile ? entry.mobile : entry.desktop;
  return getProgressBarDataTrack(name);
};

export const getStepDataTrack = (stepId, isMobile) => getDataTrack(stepId, isMobile);

export const getGroupDataTrack = (groupId, isMobile) => getDataTrack(groupId, isMobile);
